import { cn } from '@/lib/utils'

type MarketingEyebrowProps = {
  children: React.ReactNode
  className?: string
}

export function MarketingEyebrow({ children, className }: MarketingEyebrowProps) {
  return (
    <p
      className={cn(
        'mb-[18px] text-[13px] font-bold uppercase tracking-[0.12em] text-[var(--marketing-eyebrow,#9b780d)]',
        className
      )}
    >
      {children}
    </p>
  )
}
